import type {
  AgencySubscription,
  RentedSubscription,
  Subscription,
} from "common/types";

import SubscriptionPaymentMethod from "./SubscriptionPaymentMethod";

interface SubscriptionInfoProps {
  subscription:
    | Subscription
    | RentedSubscription
    | AgencySubscription
    | undefined;
  isLoading: boolean;
}

export default function SubscriptionInfo({
  isLoading,
  subscription,
}: SubscriptionInfoProps) {
  if (!subscription) {
    return null;
  }

  return (
    <SubscriptionPaymentMethod
      subscriptionId={subscription.id}
      isAgency={subscription.type === "agency"}
      isLoading={isLoading}
    />
  );
}
